export const SET_BAR_MESSAGE = "SET_BAR_MESSAGE"
export const SET_BAR_STATE_TRUE = "SET_BAR_STATE_TRUE"
export const SET_BAR_STATE_FALSE = "SET_BAR_STATE_FALSE"